export default __webpack_public_path__ + "static/media/35year.ef05d19d.svg";